import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../../config'
import Amplitude from '../../utils/amplitudeHelper'
import banner from '../../images/backdrops/tiktok-banner.png'
import TNC from '../../images/backdrops/tncM.png'
import voteBtn from '../../images/backdrops/vote-btn.png'
import routes from '../../routes'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import { useObject } from 'react-firebase-hooks/database'
import { useDispatch, useSelector } from 'react-redux'
import { getEntries } from '../../ducks/entry'
import { VotingAccessDb } from '../../firebaseConfig'
import LoadIcon from '../../components/LoadIcon'
import PreviewModal from '../../components/PreviewModal'
import { FONTS } from 'src/styles/theme'
import { SvgIcon } from 'src/components/shared/SvgIcon'
import { SvgType } from 'src/components/shared/SvgIcon/SvgIcon'

const MobileVoting = ({ currentUser }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { entries, requestLoading } = useSelector((state) => state.entry)
  const [snapshot, loading, error] = useObject(VotingAccessDb)
  const [showFinalists, setShowFinalists] = useState(true)
  const [showPreview, setShowPreview] = useState(false)
  const [previewEntry, setPreviewEntry] = useState(null)
  const [showTerms, setShowTerms] = useState(false)

  useEffect(() => {
    document.title = `${config.eventName} | TikTok Challenge`
  }, [])

  useEffect(() => {
    if (!loading) {
      if (!snapshot.val() && currentUser.role === 'participant') {
        history.push(routes.lobby)
        toast('TikTok Challenge will be available soon.')
      } else {
        Amplitude.visit('TikTok')
      }
    }
  }, [loading, snapshot, history, currentUser.id])

  useEffect(() => {
    dispatch(getEntries())
  }, [dispatch])

  const handleExpandFinalist = () => {
    setShowFinalists(!showFinalists)
  }

  const previewVideo = (entry) => {
    setPreviewEntry(entry)
    setShowPreview(true)
  }
  const closePreview = () => {
    setShowPreview(false)
    setPreviewEntry(null)
  }

  if (requestLoading) {
    return <LoadIcon />
  }
  return (
    <Page>
      {
        showTerms ?
        <div>
          <button id="close-btn" onClick={()=>setShowTerms(false)} type="button" class="close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
          <img src={TNC} width="90%" className="d-block mx-auto" alt="terms and conditions" />
        </div>
        :
        <div className="outer-wrapper">
          <div className="container">
            <header>
              <img className='my-1' width="100%" src={banner} alt="page-header"/>
              <button id="tnc" onClick={()=>setShowTerms(true)}>
                <span>Terms & Conditions</span>
                <SvgIcon type={SvgType.PLAY} />
              </button>
            </header>
            <div className='my-4' onClick={()=>history.push(routes.votingform)}>
              <img src={voteBtn} className="vote-btn" width="65%" alt="vote button" />
            </div>
            {showFinalists && entries.map(entry=>(
              <div className={`mobile-preview ${entry.video_type == 0 ? "w-100" : "w-75"}`} key={`mobile-entry-${entry.id}`}>
                <div className="photo-box">
                  <img src={entry.thumbnail.url} width="100%" className="entry-photo" onClick={()=>previewVideo(entry)}/>
                </div>
                <div className="participant-details">
                  <h6 className="entry-order">{entry.order}</h6>
                  <span className="entry-participant">{entry.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      }
      {showPreview && <PreviewModal entry={previewEntry} showModal={showPreview} closeModal={closePreview}/>}
    </Page>
  )
}

const Page = styled.div`
  background: url(${config.assets.tiktok.portrait});
  background-size: cover;
  background-position: top center;

  height: calc(100% - 60px);
  width: 100vw;
  border-radius: 0px 0px 25px 25px;
  position: absolute;
  overflow-y: scroll;
  font-family: ${FONTS.secondary};

  .outer-wrapper {
    width: 100%;
  }
  header {
    position: relative;
  }
  #close-btn {
    position: absolute;
    right: 5%;
    font-size: 52px;
    opacity: 1;
    color: #00FFFF;
    padding: 0;
    text-shadow: none;
    &:not(:disabled):hover {
      color: #00FFFF;
      opacity: 1;
    }
  }
  #tnc {
    position: absolute;
    background-color: #00B3BD;
    border: none;
    border-radius: 18px;    
    top: 76%;
    left: 45%;
    padding: 2px 8px;
    color: white;
    font-size: 75%;
    span {
      margin-right: 4px;
    }
    svg {
      width: 16px;
    }
  }
  .container {
    width: 95%;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 36px;
  }
  .mobile-preview {
    width: 90%;
    margin: 0px auto;
    margin-bottom: 18px;
  }

  .photo-box {
    margin: 0px auto;
    padding-top: 4px;
    .entry-photo {
      cursor: pointer;
      position: relative;
      margin: 0px 4px;
      opacity: 0;
      animation: appear 1s forwards;
    }
  }
  .participant-details {
    padding: 4px 18px;
    display: flex;
    text-align: left;
  }
  .entry-order {
    font-size: 38px;
    font-weight: 600;
    color: #00FFFF;
    margin-right: 12px;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
  }
  .entry-participant {
    font-weight: 500;
    color: white;
    text-transform: uppercase;
    font-size: 18px;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 600px;
      margin: auto;
    }
    
    .entry-order {
      font-size: 42px;
    }
    .entry-participant {
      font-size: 24px;
    }
  }
`

export default MobileVoting
